import { useEffect, useState } from 'react';
import homeIcon from '@/assets/menu/home.png';
import projectIcon from '@/assets/menu/project.png';
import settingIcon from '@/assets/menu/setting.png';

import './Navigation.less';
import { useNavigate } from 'react-router-dom';
export default function Dashboard() {
  const [menus, setMenus] = useState([
    {
      name: 'Home',
      icon: homeIcon,
      path: '/',
    },
    {
      name: 'Project',
      icon: projectIcon,
      path: '/project',
    },
    {
      name: 'Settings',
      icon: settingIcon,
      path: 'setting',
    },
  ]);
  const [activeMenu, setActiveMenu] = useState(menus[0]);
  const navigate = useNavigate();
  useEffect(() => {}, []);
  const clickMenu = (item) => {
    setActiveMenu(item);
    navigate(item.path);
  };
  return (
    <div className="navigation">
      {menus.map((item) => {
        return (
          <div
            onClick={() => {
              clickMenu(item);
            }}
            className={'menu-item ' + (activeMenu === item ? 'active' : '')}
            key={item.name}>
            <img className="icon" src={item.icon}></img>
            <span className="name">{item.name}</span>
          </div>
        );
      })}
    </div>
  );
}
